@if (alertMessage) {
  <notification
    [timeout]="10000"
    [severity]="alertType"
    [message]="alertMessage"
    (hideNotification)="(alertMessage == null)"
  ></notification>
}
<script src="http://maps.googleapis.com/maps/api/js"></script>
<h3 class="text-center title-event">New Event</h3>

<!-- Event type and event description-->
<div>
  <div>
    <div [ngClass]="getHeaderClass()">
      <input
        [(ngModel)]="eventTemplate.eventDesc"
        class="placeholder-description"
        placeholder="Description"
        />
      </div>

      <div class="flex-container">
        <div class="flex-child">
          <label
            (click)="eventTypeChange('OFF')"
            class="btn btn-modal-event-off-duty"
            >
            <input
              value="OFF"
              [(ngModel)]="eventTemplate.eventType"
              type="radio"
              name="option"
              id="OFF"
              />&nbsp;Off-duty
            </label>
          </div>
          <div class="flex-child">
            <label
              (click)="eventTypeChange('SICK')"
              class="btn btn-modal-event-sick"
              >
              <input
                value="SICK"
                [(ngModel)]="eventTemplate.eventType"
                type="radio"
                name="option"
                id="SICK"
                />&nbsp;Sick
              </label>
            </div>
            <div class="flex-child">
              <label
                (click)="eventTypeChange('TRAIN')"
                class="btn btn-modal-event-train"
                >
                <input
                  value="TRAIN"
                  [(ngModel)]="eventTemplate.eventType"
                  type="radio"
                  name="option"
                  id="TRAIN"
                  />&nbsp;Train
                </label>
              </div>
              <div class="flex-child">
                <label (click)="eventTypeChange('OTH')" class="btn btn-modal-event-oth">
                  <input
                    value="OTH"
                    [(ngModel)]="eventTemplate.eventType"
                    type="radio"
                    name="option"
                    id="OTH"
                    />&nbsp;Other
                  </label>
                </div>
              </div>

              <div class="flex-container">
                <div class="flex-child">
                  <label
                    (click)="eventTypeChange('TRAINZ')"
                    class="btn btn-modal-event-trainz"
                    >
                    <input
                      value="TRAINZ"
                      [(ngModel)]="eventTemplate.eventType"
                      type="radio"
                      name="option"
                      id="TRAINZ"
                      />
                      Train'z
                    </label>
                  </div>
                  <div class="flex-child">
                    <label
                      (click)="eventTypeChange('TECHZ')"
                      class="btn btn-modal-event-techz"
                      >
                      <input
                        value="TECHZ"
                        [(ngModel)]="eventTemplate.eventType"
                        type="radio"
                        name="option"
                        id="TECHZ"
                        />
                        Tech'z
                      </label>
                    </div>
                    <div class="flex-child">
                      <label
                        (click)="eventTypeChange('CONFZ')"
                        class="btn btn-modal-event-confz"
                        >
                        <input
                          value="CONFZ"
                          [(ngModel)]="eventTemplate.eventType"
                          type="radio"
                          name="option"
                          id="CONFZ"
                          />
                          Conf'z
                        </label>
                      </div>
                      <div class="flex-child">
                        <label
                          (click)="eventTypeChange('CASUALZ')"
                          class="btn btn-modal-event-casualz"
                          >
                          <input
                            value="CASUALZ"
                            [(ngModel)]="eventTemplate.eventType"
                            type="radio"
                            name="option"
                            id="CASUALZ"
                            />
                            Casual'z
                          </label>
                        </div>
                      </div>
                      <hr />
                    </div>

                    <div class="event-section">
                      <div class="event-section-header">
                        <span class="event-section-title">Additional description</span>
                      </div>
                      <textarea [(ngModel)]="eventTemplate.additionalDesc" rows="5"></textarea>
                    </div>

                    <div class="event-section">
                      <div class="event-section-header">
                        <span class="event-section-title">Localisation</span>
                      </div>
                      <textarea [(ngModel)]="eventTemplate.eventLocation" rows="5"></textarea>
                    </div>

<!-- Dates & Période -->
                    <div class="event-section">
                      <div class="event-section-header">
                        <span class="event-section-title">Dates &amp; Période</span>
                        <div class="event-allday-toggle">
                          <span class="event-section-alldaylabel">All day</span>
                          <p-toggleswitch [(ngModel)]="allDay" (onChange)="switchAllDayTag()"></p-toggleswitch>
                        </div>
                      </div>

                      <div class="event-date-row">
                        <span class="event-date-label" style="color: #27ae60">Début</span>
                        <p-datepicker
                          class="custom-p-calendar-input"
                          name="startDate"
                          [appendTo]="'body'"
                          [selectOtherMonths]="true"
                          dateFormat="yy-mm-dd"
                          dataType="string"
                          [(ngModel)]="eventTemplate.eventStartDate">
                        </p-datepicker>
                        <p-selectButton
                          name="startPeriod"
                          [class.hidden-allday]="allDay"
                          [options]="periods"
                          [allowEmpty]="false"
                          [(ngModel)]="eventTemplate.eventStartPeriod">
                        </p-selectButton>
                      </div>

                      <div class="event-date-row">
                        <span class="event-date-label color-red">Fin</span>
                        <p-datepicker
                          class="custom-p-calendar-input"
                          name="endDate"
                          [appendTo]="'body'"
                          [selectOtherMonths]="true"
                          dateFormat="yy-mm-dd"
                          dataType="string"
                          [(ngModel)]="eventTemplate.eventEndDate">
                        </p-datepicker>
                        <p-selectButton
                          name="endPeriod"
                          [class.hidden-allday]="allDay"
                          [options]="periods"
                          [allowEmpty]="false"
                          [(ngModel)]="eventTemplate.eventEndPeriod">
                        </p-selectButton>
                      </div>
                    </div>

                    <hr />

                    <!-- Notification mail -->
                    <div class="event-section">
                      <div class="event-section-header">
                        <span class="event-section-title">Notification mail</span>
                      </div>
                      <div class="event-notif-row">
                        <span>Envoyer un mail ?</span>
                        <p-selectButton
                          name="mailNotif"
                          [options]="boolValues"
                          [allowEmpty]="false"
                          [(ngModel)]="sendMailNotification">
                        </p-selectButton>
                      </div>
                    </div>

                    <hr />

                    <!-- Participants -->
                    <div class="event-section">
                      <div class="event-section-header">
                        <span class="event-section-title">Participants</span>
                      </div>
                      <div class="event-participants-toolbar">
                        <app-search-bar
                          [placeholder]="'Rechercher'"
                          [(filterParameter)]="userFilter"
                          (searchEvent)="search()"
                          (resetFilterEvent)="resetFilter()">
                        </app-search-bar>
                        <button class="btnAdminManage btn-cons" (click)="addAllItzInList()">Add All</button>
                        <button class="btnAdminManage btn-cons" (click)="delAllItzInList()">Del All</button>
                      </div>
                      <div class="customTable">
                        <table>
                          <th></th>
                          @for (user of users | filter : userFilter : true; track user) {
                            <tr class="tableEmployee" (click)="addItzInList(user)">
                              <td class="addBtn-col"><button class="addBtn"><i class="material-icons">person_add</i></button></td>
                              <td><span class="text-left">{{ user.userFirstName }} {{ user.userName }}</span></td>
                            </tr>
                          }
                        </table>
                      </div>
                      @if (userSelected.length > 0) {
                        <div class="event-selected-chips">
                          @for (users of userSelected; track users) {
                            <span class="event-chip">
                              {{ users?.userFirstName }} {{ users?.userName }}
                              <button class="removeBtn" (click)="delItzInList(users)">×</button>
                            </span>
                          }
                        </div>
                      }
                    </div>

                    <div class="event-save">
                      <button class="btnAdminManage btn-create btn-cons w-100" (click)="sendEvent()">SAVE</button>
                    </div>
                    </div>
